<template>
  <div>
    <div class="flex justify-end">
      <Create
        @click="router.push('/fighters/new')"
        :icon="UserPlusIcon"
        :label="'Adicionar'"
        :menu-active="'Lutadores'"
      />
    </div>

    <section>
      <div class="relative overflow-x-auto shadow-md sm:rounded-lg min-h-[25vh] p-2">

        <div class="flex items-center justify-between flex-column flex-wrap md:flex-row space-y-4 md:space-y-0 pb-4 bg-white">
          <SearchInput v-model="searchTerm" />
        </div>

        <DataTable
          :key="dataTable"
          :data="filteredData"
        >
          <template #head>
            <th scope="col" class="px-6 py-3">Nome</th>
            <th scope="col" class="px-6 py-3">Usuário</th>
            <th scope="col" class="px-6 py-3">Turmas</th>
            <th scope="col" class="px-6 py-3 text-center">#</th>
          </template>
        </DataTable>
      </div>
    </section>

  </div>
</template>

<script setup>
import SearchInput from '@/components/Tables/SearchInput.vue'
import CollabService from './services/collab.service'
import Create from '@/components/Buttons/Create.vue'
import DataTable from './components/DataTable.vue'
import router from '@/router'
import { storeApp } from '@/store'
import { onBeforeMount, ref, computed } from 'vue'

import { UserPlusIcon } from '@heroicons/vue/24/outline'
import { dataFighters } from './store'
import { PdfCreate } from '@/utils/reports/generate-blob'

const dataTable = computed(() => dataFighters.getters.getFighters)
const searchTerm = ref('')

// fluxo dos groups
async function excel (id) {
  storeApp.state.loading = true

  const url = `${process.env.VUE_APP_API_URL}app/groups/${id}/report`
  const report = new PdfCreate(url)

  return await report.fetchExcelByItemId(id).finally(() => {
    storeApp.state.loading = false
  })
}

const filteredData = computed(() => {
  const searchTermLower = searchTerm.value?.toLowerCase()

  return dataTable?.value?.filter((row) => {
    const matchesSearch = !searchTerm.value ||
      ['name', 'email', 'phone'].some(
        (key) =>
          row[key] && row[key].toString().toLowerCase().includes(searchTermLower)
      )

    return matchesSearch
  })
})

onBeforeMount(async () => {
  dataFighters.dispatch('difineConfigsForPage', {
    title: 'Alunos',
    subtitle: 'Faça a gestão de todos os alunos da plataforma'
  })
})

// async function getCustomers () {
//   await CollabService.getCustomers()
//     .then(res => {
//       console.log(res.data)
//       dataTable.value = res.data
//       dataFighters.dispatch('setFightersCollect', res.data)
//     }).catch(err => {
//       toast(
//         'Erro',
//         'Algo deu errado ao buscar lutadores',
//         'error'
//       )
//     })
// }

</script>
